import { cn } from "@shortsworks/ui/lib/utils";
import { DesktopSkeletonHeader } from "@app/components/WidgetStudio/Canvas/skeletons/DesktopSkeleton/Header";
import { DesktopSkeleton } from "@app/components/WidgetStudio/Canvas/skeletons/DesktopSkeleton";
import { MobileSkeleton } from "@app/components/WidgetStudio/Canvas/skeletons/MobileSkeleton";
import { useState } from "react";
import { DeviceType } from "@app/components/WidgetStudio";
import { ShortsWorksWidgetProps } from "@app/components/WidgetStudio/ShortsWorksWidget";

interface CanvasProps {
  className?: string;
  device?: DeviceType;
  widgetProps: ShortsWorksWidgetProps;
}

export const Canvas = ({ className, device, widgetProps }: CanvasProps) => {
  return (
    <div
      className={cn("flex flex-col w-full h-full overflow-hidden", className)}
    >
      <div className="flex items-start justify-center h-full p-5 pb-0 flex-grow">
        <div
          className={cn(
            "border-t border-l border-r border-input overflow-hidden transition-all",
            device === "desktop"
              ? "w-full min-w-[500px] max-w-[1200px] h-full rounded-tl-lg rounded-tr-lg"
              : "w-[430px] h-4/5 rounded-tl-3xl rounded-tr-3xl h-full",
          )}
        >
          {device === "desktop" ? (
            <DesktopSkeleton widgetProps={widgetProps} />
          ) : (
            <MobileSkeleton widgetProps={widgetProps} />
          )}
        </div>
      </div>
    </div>
  );
};
